module.exports = "<section class=\"delegated-card-request-counter-container\" ng-if=\"$ctrl.hasMonthEmpty()\">\n  <span class=\"counter-number\">{{$ctrl.monthsEmptyCounter }}</span>\n  <span class=\"counter-label\">meses</span>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardRequestCounter/delegatedCardRequestCounter.html
// module id = 1720
// module chunks = 0